var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alert-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.806,
    height: 27.535,
    viewBox: "0 0 30.806 27.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38776",
    "data-name": "Path 38776",
    d: "M13.686,20.586a1.343,1.343,0,1,1-1.343-1.343A1.343,1.343,0,0,1,13.686,20.586ZM13.35,9.507a1.007,1.007,0,1,0-2.014,0V15.55a1.007,1.007,0,0,0,2.014,0Z",
    transform: "translate(3.06 0.235)",
    fill: "#f5353e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38777",
    "data-name": "Path 38777",
    d: "M13.027,3.672a3.356,3.356,0,0,1,5.812,0L30.88,24.492a3.359,3.359,0,0,1-2.907,5.038H3.893A3.358,3.358,0,0,1,.985,24.492ZM17.1,4.681a1.343,1.343,0,0,0-2.326,0L2.73,25.5a1.343,1.343,0,0,0,1.163,2.016H27.973A1.343,1.343,0,0,0,29.136,25.5L17.1,4.679Z",
    transform: "translate(-0.53 -1.995)",
    fill: "#f5353e",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5213a477e410b384885800d03136485c.svg";
export { ForwardRef as ReactComponent };